import './viewedTmdbItems.scss';
import React, {useCallback, useEffect, useRef, useState} from "react";
import {Spinner, TitlePage} from "../../../../../shared";
import UseSquadflixNavigate from "../../../../../cap17drive/squadflixHome/useSquadflixNavigate";
import ItemTmdbBtnV2, {ItemTbdbBtnV2Props} from "../../../../../shared/itemTmdbBtnV2/itemTmdbBtnV2";
import {ScrollModalApi} from "../../../../../shared/scroll-modal/view";
import {countItemTotalEpisodes, countItemTotalSeasons, getLocalDateTimeString} from "../../../../../../utils/utils";
import ItemsHorizontalScroll from "../../../../../cap17drive/shared/itemsHorizontalScroll/itemsHorizontalScroll";
import {ScrollModal} from "../../../../../shared/scroll-modal";
import TmdbResultCard from "../../../../../cap17drive/tmdbResultCard/tmdbResultCard";
import {SquadflixLogsApi} from '../../../../../../apis/squadflix-logs/SquadflixLogsApi';


const ViewedTmdbItems = () => {

    const squadflixNav = UseSquadflixNavigate({});
    const [pagination, setPagination] = useState<TmdbViewPagination>(undefined);
    const [initialLoading, setInitialLoading] = useState(true);
    const [loading, setLoading] = useState(false);
    const [loadingNextPage, setLoadingNextPage] = useState(false);
    const loadedPages = useRef<Record<number, TmdbViewPagination>>({});
    const itemsRef = useRef<ItemTbdbBtnV2Props[]>([]);
    const [items, setItems] = useState<ItemTbdbBtnV2Props[]>([]);
    const loadingPageNumRef = useRef(0);
    const lastPageRef = useRef(0);
    const [selectedItem, setSelectedItem] = useState<UserTmdbViewItem>(null);
    const itemDetailsScrollModal = useRef<ScrollModalApi>(null);

    const fetchPage = useCallback(async (page: number) => {
        setLoading(true);
        loadingPageNumRef.current = page;
        return SquadflixLogsApi.getMyViewedItems({page}).then((res: TmdbViewPagination) => {
            setPagination(res);
            lastPageRef.current = page;
            setLoading(false);
            setInitialLoading(false);
        }).catch(e => {
            setLoading(false);
        });
    }, [setLoading]);

    useEffect(() => {
        setInitialLoading(true);
        fetchPage(1);
    }, [fetchPage]);

    const navigateToItem = (item: UserTmdbViewItem) => {
        item.isMovie
            ? squadflixNav.navigateToMovie(item.item)
            : squadflixNav.navigateToSerie(item.item);
    }

    const handleSelectItem = (item: UserTmdbViewItem) => {
        setSelectedItem(item);
        itemDetailsScrollModal.current?.open();
    }

    useEffect(() => {
        if (!pagination) return;
        if (loadingNextPage) {
            if (!itemsRef.current.some(x => x.loading)) {
                itemsRef.current.push({tmdbItem: undefined, loading: true});
                setItems([...itemsRef.current]);
            }
            return;
        }

        const loadingIndex = itemsRef.current.findIndex(x => x?.loading);
        if (loadingIndex !== -1) {
            itemsRef.current.splice(loadingIndex, 1);
        }

        if (loadedPages.current[pagination.page]) return;

        itemsRef.current.push(...pagination.items.map((item) => ({
            tmdbItem: item.item,
            onClick: () => {
                if (item.isMovie) {
                    navigateToItem(item);
                    return;
                }
                handleSelectItem(item);
            },
            type: item.isMovie ? 'movie' : 'tv' as ItemTbdbBtnV2Props["type"],
            bottomInfo: (!item.isMovie && item.episodes) ? <>
                <div style={{textAlign: "right"}}>
                    S{item.episodes[0].season}E{item.episodes[0].episode}
                </div>
                <div className="text-muted" style={{fontSize: '0.9em'}}>
                    {item.episodes.length}/{countItemTotalEpisodes(item.item)} episodios
                </div>
            </> : undefined,
            description: getLocalDateTimeString(item.viewDate)
        })));
        loadedPages.current[pagination.page] = pagination;
        setItems([...itemsRef.current]);

    }, [loadingNextPage, pagination, squadflixNav]);

    const handleLoadNextPage = useCallback(() => {
        if (!loadedPages.current[1]) return;
        const lastPagination = loadedPages.current[Object.keys(loadedPages.current).length];
        if (lastPagination.page >= lastPagination.totalPages) return;
        if (loadingPageNumRef.current > lastPageRef.current) return;
        setLoadingNextPage(true);
    }, []);

    useEffect(() => {
        if (loading) return;
        if (!loadingNextPage) return;
        if (!pagination) {
            setLoadingNextPage(false);
            return;
        }
        if (pagination.page >= pagination.totalPages) {
            setLoadingNextPage(false);
            return;
        }
        fetchPage(pagination.page + 1).then(() => {
            setLoadingNextPage(false);
        });

    }, [loadingNextPage, loading, pagination, fetchPage]);

    if (initialLoading) {
        return <div style={{height: "272px", overflow: "hidden"}}>
            <TitlePage
                title={<span>Cosas que has visto</span>}
                icon="fa-solid fa-eye"
                leftClass="col-12"
                disableScroll
                hideSeparator
                titleClass="mb-2 ps-1"
                fixedHeight="27px" rightOptions={undefined} rightClass={undefined} className={undefined}
                style={undefined}/>
            <div className="d-flex justify-content-center align-items-center" style={{
                padding: "20px",
                height: "237px",
            }}>
                <Spinner className={undefined}/>
            </div>
        </div>;
    }

    return (
        <>
            <div style={{height: "fit-content", overflow: "hidden"}}>
                <TitlePage
                    title={<span>Cosas que has visto</span>}
                    icon="fa-solid fa-eye"
                    leftClass="col-12"
                    disableScroll
                    hideSeparator
                    titleClass="mb-2 ps-1"
                    fixedHeight="27px" rightOptions={undefined} rightClass={undefined} className={undefined}
                    style={undefined}/>
                <ItemsHorizontalScroll onScrollEnd={handleLoadNextPage}>
                    {
                        items.map((item, index) => (
                            <ItemTmdbBtnV2
                                key={index}
                                {...item}
                            />
                        ))
                    }
                    {items.length === 0 && <div className="text-muted" style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        height: "227px",
                    }}>Aquí aparecerán los episodios o peliculas que marques como vistos.</div>}
                </ItemsHorizontalScroll>
            </div>
            <ScrollModal ref={itemDetailsScrollModal} header={selectedItem &&
                <div>
                    <TmdbResultCard props={selectedItem.item} from={undefined}
                                    customBottomInfo={
                                        <div className="text-muted" style={{fontSize: '0.9em'}}>
                                            {selectedItem.episodes.length}/{countItemTotalEpisodes(selectedItem.item)} episodios
                                            | {countItemTotalSeasons(selectedItem.item)} temporada/s
                                        </div>
                                    }
                                    onClick={() => {
                                        navigateToItem(selectedItem);
                                    }}/>
                </div>

            }>
                {selectedItem && <div style={{padding: 20}}>
                    {!selectedItem.isMovie && selectedItem.episodes && selectedItem.episodes.length > 0 &&
                        <table className="table table-striped">
                            <thead>
                            <tr>
                                <th>
                                    Episodio
                                </th>
                                <th>
                                    Visto el
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {selectedItem.episodes.map((ep, idx) => (
                                <tr key={`S${ep.season}E${ep.episode}`}>
                                    <td style={{paddingTop: 10, paddingBottom: 10}}>
                                        S{ep.season}E{ep.episode}
                                    </td>
                                    <td>
                                        {getLocalDateTimeString(ep.viewDate)}
                                    </td>
                                </tr>
                            ))}
                            </tbody>

                        </table>
                    }
                </div>}
            </ScrollModal>
        </>
    );
}

export default ViewedTmdbItems;


type UserTmdbViewEpisode = {
    season: number;
    episode: number;
    view: boolean;
    viewDate: Date;
}

type UserTmdbViewItem = {
    uid: string;
    isMovie: boolean;
    tmdbId: number;
    item: any;
    viewLater: boolean;
    view: boolean;
    viewDate: Date | null;
    episodes: UserTmdbViewEpisode[] | null;
}

type TmdbViewPagination = {
    page: number;
    totalPages: number;
    totalItems: number;
    items: UserTmdbViewItem[];
}
